import { Component, OnInit, Input } from '@angular/core';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';

@Component({
  selector: 'app-factuuradressenlist',
  templateUrl: './factuuradressenlist.component.html',
  styleUrls: ['./factuuradressenlist.component.less']
})
export class FactuuradressenlistComponent implements OnInit {

  @Input() relatieid: number;

  adressen: any = null;


  constructor(private relatiesService: RelatiesService) { }

  ngOnInit() {
    this.relatiesService.getFactuurAdressen(this.relatieid).subscribe(data => {
      this.adressen = data;
    })
  }

  deleted(id: number) {
    this.adressen.forEach( (item, index) => {
        if(item.ID === id) {
          this.adressen.splice(index,1);
        }
    });
  }


  addNew(): void {
    this.relatiesService.addFactuurAdres(this.relatieid).subscribe(data => {
        this.adressen.push({
            ID : data.ID,
            BedrijfNummer : this.relatieid,
            FactuurAdres : '',
            DebiteurNummer : '',
            Opmerking : '',
            BTWNr : ''
        })
    })
  }

}
